import { createContext } from 'preact';

export const DragAndDropContext = createContext({
  drake: null,
});
